<template>
    <v-dialog v-model="dialog" max-width="1000px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            dark
            class="mx-2"
            v-bind="attrs"
            v-on="on"
            >เพิ่ม</v-btn>
        </template>

        <v-card outlined class="pa-3">
                <v-card-title ><strong>{{$t('package_title')}}</strong></v-card-title>
                <v-divider class="ma-2"></v-divider>
                <div class="pl-5 pr-5">
                    <v-form ref="formData" lazy-validation>
                    <v-row>
                        <v-col>
                            <v-text-field outlined autofocus
                                :rules="[rules.required]"
                                :label="$t('package_name_label')" 
                                v-model="editedItem.package_name">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col>
                            <v-text-field outlined 
                                :label="$t('package_noti_label')"
                                :rules="[rules.requiredNumber]"
                                v-model="editedItem.line_noti_per_month">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field outlined 
                                :label="$t('package_supervisor_label')" 
                                :rules="[rules.requiredNumber]"
                                v-model="editedItem.supervisor">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field type="number" outlined 
                                :label="$t('package_viewer_label')" 
                                :rules="[rules.requiredNumber]"
                                v-model="editedItem.viewer">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field outlined 
                                :label="$t('package_noti_fee_label')" 
                                v-model="editedItem.line_noti_member_fee">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field outlined 
                                :label="$t('package_member_fee_label')" 
                                v-model="editedItem.member_fee">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field outlined 
                                :label="$t('package_platform_charge_label')" 
                                v-model="editedItem.platform_service_charge">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <!--
                    <v-row>
                        <v-col>
                            <v-text-field outlined 
                                :label="$t('package_msg_charge_label')" 
                                v-model="editedItem.line_message_service_charge">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field outlined 
                                :label="$t('package_platform_charge_label')" 
                                v-model="editedItem.platform_service_charge">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    -->
                    <v-row >
                        <!--
                        <v-col>
                            <v-checkbox 
                                :label="$t('package_lineoa_label')"
                                v-model="editedItem.line_oa">
                            </v-checkbox>
                        </v-col>
                        -->
                        <v-col>
                            <v-checkbox 
                                :label="$t('package_branch_label')"
                                v-model="editedItem.branch">
                            </v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox 
                                :label="$t('package_reserve_label')"
                                v-model="editedItem.reservation">
                            </v-checkbox>
                        </v-col>
                        <v-col>
                            <v-checkbox 
                                :label="$t('package_appoint_label')"
                                v-model="editedItem.appointment">
                            </v-checkbox>
                        </v-col>
                    </v-row>
                    </v-form> 
                </div>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveDialog">บันทึก</v-btn>
                    <v-btn color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<script>

import axios from 'axios';
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'

export default {
    name: 'DlgPackage',
    data: () => ({
        rules: {
            required: value => !!value || 'กรุณากรอกข้อมูล.',
            requiredNumber: value => !!value || 'กรุณากรอกข้อมูลที่เป็นตัวเลข',
        },
        dialog: false,
        editedItem: {},
        isEdit: false
    }),
    methods: {
        saveDialog() {
            if (!this.$refs.formData.validate()) {
                return;
            }
            let url = this.isEdit ? config.api.url.manage.package.update_package + this.editedItem.package_id : config.api.url.manage.package.insert_package;
            var que = this.$store.commit('addLoading')
            axios.post(url, this.editedItem, { headers: Staff.getTokenHeader()}).then(() => {
                this.$store.commit('finishLoading',que)
                 this.closeDialog(true);
            })
            .catch(error => {
                this.$store.commit('finishLoading',que)
                this.$router.push({name:'Error',params:error});
            });
           
        },
        closeDialog(ret) {
            this.editedItem = {};
            this.dialog = false;
            this.isEdit = false;
            this.$emit("onCloseDialog", ret);
        },
        show(item) {
            this.dialog = true;
            this.editedItem = item;
            this.isEdit = true;
        }
    }
}
</script>